import React, { useState, useEffect } from "react";
// import "./termsTab.scss";
import { Row, Col, Tabs } from "antd";

const { TabPane } = Tabs;

const Content1 = () => (
  <div>
    <p className="paragraphText">Effective Date: March 24th, 2021</p>
    <div className="commonListStyle paragraphText">
      This Privacy Statement (“Privacy Statement”) explains how Fyndr, LLC., its
      affiliates, and its subsidiaries (“Fyndr,” “us,” “our,” and “we”) use your
      information that applies to all who use our websites and platforms –
      including mobile applications, touch technologies, electronic services,
      social networking sites, interactive features, online services or any of
      our described online activities we own or control (collectively, the
      “Service”). For terms that govern the use of the Service, please review
      the Service’s Terms of Use on our website www.fyndr.us or on mobile app
      (Menu 🡪 Terms & Privacy Policy) By using the Service, you acknowledge you
      have read the terms of this Privacy Statement. If you do not want your
      information handled as described in this Privacy Statement, please do not
      provide us with your information or interact with the Service. We may
      modify this Privacy Statement at any time. If we make any material
      changes, we will notify you by email (sent to the email address specified
      in your account) or by means of notice on the Service prior to the change
      becoming effective. You can determine when this Privacy Statement was last
      revised by referring to the "Effective Date” above. This Privacy Statement
      is organized as follows:
      {/* <li>
        You have reached the age of majority in the state or province in which
        you reside
      </li>
      <li>You are able to create a binding legal obligation</li>
      <li>
        You will use this platform in good faith while notifying your
        interactions about a possible exposure to a health hazard you may have
        been subjected to.
      </li>
      <li>
        You receive the notification in good faith and only as a cautionary
        measure to minimize the spread of such exposure within the community.
      </li>
      <li>
        You are not barred from receiving products or services under applicable
        law
      </li>
      <li>
        You will not attempt to use the Site with crawlers, robots, data mining,
        or extraction tools or any other functionality. Your use of the Site
        will at all times comply with these Terms of Use.
      </li>
      <li>
        You will only make legitimate purchases that comply with the letter and
        spirit of the terms of the respective offers.
      </li>
      <li>
        You will only make purchases on the Site for your own use and enjoyment
        or as a gift for another person.
      </li>
      <li>
        You have the right to provide any and all information you submit to the
        Site, and all such information is accurate, true, current, and complete.
      </li>
      <li>
        You will update and correct information you have submitted to the Site,
        including all account information, and ensure that it is accurate at all
        times (out-of-date information will invalidate your account).
      </li>
      <li>
        You will only purchase a Business Offering, Product, or participate in
        other available programs through the Site by creating an account or
        using the guest checkout feature on the Site, and any purchase will be
        subject to the applicable Terms of Sale set forth in these Terms of Use.
      </li> */}
    </div>
  </div>
);

const Content2 = () => (
  <div>
    <p className="paragraphText">
    Effective Date: March 24th, 2021
    </p>
    <div className="commonListStyle paragraphText">
    This Privacy Statement (“Privacy Statement”) explains how Fyndr, LLC., its
      affiliates, and its subsidiaries (“Fyndr,” “us,” “our,” and “we”) use your
      information that applies to all who use our websites and platforms –
      including mobile applications, touch technologies, electronic services,
      social networking sites, interactive features, online services or any of
      our described online activities we own or control (collectively, the
      “Service”). For terms that govern the use of the Service, please review
      the Service’s Terms of Use on our website www.fyndr.us or on mobile app
      (Menu 🡪 Terms & Privacy Policy) By using the Service, you acknowledge you
      have read the terms of this Privacy Statement. If you do not want your
      information handled as described in this Privacy Statement, please do not
      provide us with your information or interact with the Service. We may
      modify this Privacy Statement at any time. If we make any material
      changes, we will notify you by email (sent to the email address specified
      in your account) or by means of notice on the Service prior to the change
      becoming effective. You can determine when this Privacy Statement was last
      revised by referring to the "Effective Date” above. This Privacy Statement
      is organized as follows:
      {/* <li>
        You have reached the age of majority in the state or province in which
        you reside
      </li>
      <li>You are able to create a binding legal obligation</li>
      <li>
        You will use this platform in good faith while notifying your
        interactions about a possible exposure to a health hazard you may have
        been subjected to.
      </li>
      <li>
        You receive the notification in good faith and only as a cautionary
        measure to minimize the spread of such exposure within the community.
      </li>
      <li>
        You have the right to provide any and all information you submit to the
        Site, and all such information is accurate, true, current, and complete.
      </li>
      <li>
        You will update and correct information you have submitted to the Site,
        including all account information, and ensure that it is accurate at all
        times (out-of-date information will invalidate your account).
      </li>
      <li>
        You will only purchase a Business Offering, Product, or participate in
        other available programs through the Site by creating an account or
        using the guest checkout feature on the Site, and any purchase will be
        subject to the applicable Terms of Sale set forth in these Terms of Use.
      </li> */}
    </div>
  </div>
);

const Content3 = () => (
  <div>
    <p className="paragraphText">
    Effective Date: March 24th, 2021
    </p>
    <div className="commonListStyle paragraphText">
    This Privacy Statement (“Privacy Statement”) explains how Fyndr, LLC., its
      affiliates, and its subsidiaries (“Fyndr,” “us,” “our,” and “we”) use your
      information that applies to all who use our websites and platforms –
      including mobile applications, touch technologies, electronic services,
      social networking sites, interactive features, online services or any of
      our described online activities we own or control (collectively, the
      “Service”). For terms that govern the use of the Service, please review
      the Service’s Terms of Use on our website www.fyndr.us or on mobile app
      (Menu 🡪 Terms & Privacy Policy) By using the Service, you acknowledge you
      have read the terms of this Privacy Statement. If you do not want your
      information handled as described in this Privacy Statement, please do not
      provide us with your information or interact with the Service. We may
      modify this Privacy Statement at any time. If we make any material
      changes, we will notify you by email (sent to the email address specified
      in your account) or by means of notice on the Service prior to the change
      becoming effective. You can determine when this Privacy Statement was last
      revised by referring to the "Effective Date” above. This Privacy Statement
      is organized as follows:
      {/* <li>
        You have the right to provide any and all information you submit to the
        Site, and all such information is accurate, true, current, and complete.
      </li>
      <li>
        You will update and correct information you have submitted to the Site,
        including all account information, and ensure that it is accurate at all
        times (out-of-date information will invalidate your account).
      </li>
      <li>
        You will only purchase a Business Offering, Product, or participate in
        other available programs through the Site by creating an account or
        using the guest checkout feature on the Site, and any purchase will be
        subject to the applicable Terms of Sale set forth in these Terms of Use.
      </li> */}
    </div>
  </div>
);

const tabData = [
  {
    title: "Privacy Statement",
    key: "1",
    content: <Content1 />,
  },
  {
    title: "Types of Information We Collect",
    key: "2",
    content: <Content2 />,
  },
  {
    title: "How Fyndr Collects Information",
    key: "3",
    content: <Content3 />,
  },
  {
    title: "Collects Information",
    key: "4",
    content: <Content1 />,
  },
  {
    title: "Uses Information",
    key: "5",
    content: <Content2 />,
  },
  {
    title: "Discloses Information",
    key: "6",
    content: <Content3 />,
  },
  {
    title: "Security of Personal Information",
    key: "7",
    content: <Content1 />,
  },
  {
    title: "Disclaimer Of Warranty",
    key: "8",
    content: <Content2 />,
  },
  {
    title: "Your Rights Regarding Personal Information",
    key: "9",
    content: <Content3 />,
  },
  {
    title: "Your Choices",
    key: "10",
    content: <Content1 />,
  },
  {
    title: "Social Community Areas",
    key: "11",
    content: <Content2 />,
  },
  {
    title: "Privacy Practices of Third Parties",
    key: "12",
    content: <Content3 />,
  },
  {
    title: "Transfers and Corporate Changes",
    key: "13",
    content: <Content1 />,
  },
  {
    title: "Notice to Residents of Countries ",
    key: "14",
    content: <Content2 />,
  },
  {
    title: "Contact Us",
    key: "15",
    content: <Content3 />,
  },
  //   {
  //     title: "Dispute Resolution/arbitration Agreement",
  //     key: "16",
  //     content: <Content1 />,
  //   },
  //   {
  //     title: "Additional Disclosures",
  //     key: "17",
  //     content: <Content2 />,
  //   },
];

interface TermsContentProps {
  content: React.ReactNode;
}

const TermsContent: React.FC<TermsContentProps> = ({ content }) => (
  <Row align={"middle"} justify={"center"}>
    <Col
      span={24}
      className="bdBlueOrangeGrad"
      style={{ marginBottom: "0px", minHeight: "122vh" }}
    >
      <span>
        <Col
          span={24}
          style={{ textAlign: "left", padding: "2vw", minHeight: "117.5vh" }}
        >
          {content}
        </Col>
      </span>
    </Col>
  </Row>
);

const Policy = () => {
  return (
    <Row className="terms-main">
      <p className="terms-para">Privacy Statement Structure</p>
      <Col xs={0} sm={0} md={24}>
        <Tabs tabPosition={"left"} className="term-tab">
          {tabData.map((tab) => (
            <TabPane tab={tab.title} key={tab.key} className="term-tab">
              <TermsContent content={tab.content} />
            </TabPane>
          ))}
        </Tabs>
      </Col>
      <Col xs={24} sm={24} md={0}>
        <Tabs tabPosition={"top"} className="term-tab">
          {tabData.map((tab) => (
            <TabPane tab={tab.title} key={tab.key} className="term-tab">
              <TermsContent content={tab.content} />
            </TabPane>
          ))}
        </Tabs>
      </Col>
    </Row>
  );
};

export default Policy;
